import { render, staticRenderFns } from "./CreatNewCoach.vue?vue&type=template&id=d485d11c"
import script from "./CreatNewCoach.vue?vue&type=script&lang=js"
export * from "./CreatNewCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports